module.exports = "/build/web/images/logo-boels-rental.f7de2469b55d2b3068bebef7ced95ab5.jpeg";


//////////////////
// WEBPACK FOOTER
// ./images/logo-boels-rental.jpeg
// module id = 123
// module chunks = 11